import { err, ok, Result, ResultAsync } from "neverthrow";
import { z, ZodError } from "zod";
import { buildInvalidError } from "./error.js";
/**
 * Transforms a value that requires Zod parsing into a Result.
 * Requires that the incoming value is the right TypeScript type for the schema.
 * @param value
 * @returns
 */
export const parsed = (schema, value) => {
    const result = schema.safeParse(value);
    if (!result.success) {
        return err(result.error);
    }
    return ok(result.data);
};
export function mustParse(schema, message) {
    return (value) => {
        const result = schema.safeParse(value);
        return result.success
            ? ok(result.data)
            : err(buildInvalidError({
                message,
                issues: [z.prettifyError(result.error)],
            }));
    };
}
/**
 * Transforms a value that requires Zod parsing into a Result.
 * Requires that the incoming value is the right TypeScript type for the schema
 * but strips any branding from the value.
 * This is currently experimental and may blow up the TypeScript compiler.
 * @param value
 * @returns
 */
// export const parsedWithoutBranding = <Schema extends ZodType<any>>(
//   schema: Schema,
//   value: DeepUnbrand<z.infer<Schema>>,
// ): Result<z.infer<Schema>, z.ZodError> => {
//   const result = schema.safeParse(value);
//   if (!result.success) {
//     return err(result.error);
//   }
//   return ok(result.data);
// };
/**
 * Transforms a value that requires Zod parsing into a Result.
 * Accepts any incoming value.
 * @param value
 * @returns
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const parsedAny = (schema, value) => {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-argument, @typescript-eslint/no-explicit-any
    return parsed(schema, value);
};
export function mustParseAny(schema, message) {
    return (value) => {
        const result = schema.safeParse(value);
        return result.success
            ? ok(result.data)
            : err(buildInvalidError({
                message,
                issues: [z.prettifyError(result.error)],
            }));
    };
}
/**
 * Transforms a value that requires Zod async parsing into a ResultAsync.
 * @param value
 * @returns
 */
export const parsedAsync = (schema, value) => {
    return ResultAsync.fromPromise(schema.parseAsync(value).then((data) => data), (error) => error);
};
/**
 * Transforms a value that requires Zod async parsing into a ResultAsync.
 * @param value
 * @returns
 */
export const parsedAnyAsync = (schema, value) => {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-argument, @typescript-eslint/no-explicit-any
    return parsedAsync(schema, value);
};
//# sourceMappingURL=parsed.js.map